<template>
    <div class="OrganisationTopRanking">
        <div class="RankingContainer">
            <div class="PositionContainer">
                <span class="Position">
                    #{{ position }}
                </span>
            </div>

            <span class="Ranking" >
                {{ ranking }}
            </span>
        </div>

        <template v-if="globalPercentage">
            <Separator />
            <span class="WorldwidePosition">
                <b>Top {{ globalPercentage }}%</b> Global Rank
            </span>
        </template>
    </div>
</template>

<script setup lang="ts">
import { computed, PropType } from 'vue';
import Separator from '@components/Separator/Separator.vue';

const props = defineProps({
	position: {
		type: Number,
		required: true,
	},
    discipline: {
        type: String,
        default: null,
    },
    globalPercentage: {
        type: [String, null] as PropType<string | null>,
        default: null,
    },
});

const ranking = computed(() => {
    if (!props.discipline) return 'Worldwide';

    return `${props.discipline} Worldwide`;
});
</script>

<style scoped lang="scss">
    .OrganisationTopRanking {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 0.25rem;

        @include Breakpoint(Small, Medium) {
            flex-wrap: wrap;
            justify-content: flex-start;
            @include MarginAreas(0.5, 0, 0, 0);
        }

        .RankingContainer {
            display: flex;
            align-items: center;
            gap: 0.5rem;

            .PositionContainer {
                background-color: $Blue-100;
                border-radius: 0.25rem;
                box-sizing: border-box;
                display: flex;
                align-items: center;
                justify-content: center;
                width: max-content;
                min-width: 2.5rem;
                height: 2.5rem;
                flex-shrink: 0;
                user-select: none;

                @include PaddingAreas(0.5);

                .Position {
                    color: $Blue-800;

                    @include TextStyle(UiMediumSemibold);
                }
            }

        }

        .Ranking {
            color: $Grey-900;

            @include TextStyle(BodyMediumSemibold);
        }
        .WorldwidePosition {
            color: $Grey-900;

            @include TextStyle(UiMediumRegular);

            b {
                @include TextStyle(BodyMediumSemibold);
            }
        }
    }
</style>